"use client";
import { memo, useEffect } from "react";
import { useRef } from "react";
interface CarouselVideoItemProps {
	videoUrl?: string;
	isActive?: boolean;
	href?: string;
}
const CarouselVideoItem: React.FC<CarouselVideoItemProps> = ({
	videoUrl,
	isActive,
	href = "",
}) => {
	const videoRef = useRef<HTMLVideoElement>(null);
	useEffect(() => {
		if (isActive) {
			videoRef.current?.play();
		} else {
			videoRef.current?.pause();
		}
	}, [isActive]);
	return (
		<div className="carousel-item video bg-gray-100 flex items-center justify-center w-full h-full">
			<div className="w-full aspect-video">
				{videoUrl ? (
					<video
						ref={videoRef}
						controls={false}
						autoPlay={false}
						className="w-full h-full object-cover"
					>
						<source src={videoUrl} type="video/mp4" />
						Your browser does not support the video tag.
					</video>
				) : (
					<div className="">no video</div>
				)}
			</div>
		</div>
	);
};
export default memo(CarouselVideoItem);
